/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ApiBody } from './apiBody';
import { ApiHeaders } from './apiHeaders';
import { ApiParams } from './apiParams';
import { LocalContent } from './localContent';
import { VasServiceTypeEnum } from './vasServiceTypeEnum';


export interface PartnerContentDto { 
    contentName?: string;
    contentPartnerName?: string;
    serviceCode?: string;
    contentType: number;
    filterExpression?: string;
    relayConnectionType: number;
    networkOperatorCode?: string;
    serviceTypeName?: string;
    serviceType: VasServiceTypeEnum;
    contentRequestRoute?: string;
    apiBaseUrl?: string;
    apiMethodType?: string;
    grantType?: string;
    apiUserName?: string;
    apiKey?: string;
    apiPassword?: string;
    smppSystemId?: string;
    systemType?: string;
    smppPassword?: string;
    smppIpAddress?: string;
    smppPort?: string;
    active: number;
    dateCreated: Date;
    description?: string;
    serviceProviderId?: string;
    partnerId: number;
    localContents?: Array<LocalContent>;
    headers?: Array<ApiHeaders>;
    params?: Array<ApiParams>;
    bodies?: Array<ApiBody>;
    urlMethod?: string;
}
